import { http } from 'utils'
import { SET_ITEMS, ADD_ITEMS, SET_META } from 'vx/mutations'
import { concat } from 'lodash'
import firestations from './firefighters/firestations'
import businessUnits from './firefighters/business-units'
import districts from './firefighters/districts'

export default {
  namespaced: true,

  state: {
    firefighters: [],
    meta: null
  },

  modules: {
    firestations,
    businessUnits,
    districts
  },

  actions: {
    async getFirefighters ({ commit }, { params = {} } = {}) {
      const response = await http.get('firefighters')

      commit(ADD_ITEMS, response.data.data)

      return response
    },

    resetFirefighters ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.firefighters = items
    },

    [ADD_ITEMS] (state, items) {
      state.firefighters = concat(state.firefighters, items)
    },

    [SET_META] (state, meta) {
      state.meta = meta
    }
  }
}
